module.exports = __webpack_public_path__ + "img/footer-bar-bg.d18ac251.svg";